import { FleetTask, VehicleJourneySegment } from "./types"

export const formatDistance = (meters?: number): string => {
	if (meters === undefined || meters === null) return "N/A"
	return meters >= 1000 ? `${(meters / 1000).toFixed(1)} km` : `${meters} m`
}

export const formatTimeWindow = (
	startTime?: string,
	endTime?: string
): string => {
	if (!startTime || !endTime) return ""
	const start = new Date(startTime)
	const end = new Date(endTime)
	return `${start.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })} - ${end.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" })}`
}

export const getColorForVehicle = (vehicleId: string): string => {
	const colors = [
		"#E63946",
		"#00B4D8",
		"#0077B6",
		"#F77F00",
		"#06D6A0",
		"#FFD60A",
		"#B5179E",
		"#D946EF",
		"#FF8C42",
		"#2ECC71",
	]

	let hash = 5381
	for (let i = 0; i < vehicleId.length; i++) {
		hash = (hash << 5) + hash + vehicleId.charCodeAt(i)
	}

	return colors[Math.abs(hash % colors.length)]
}

export const getTaskForStop = (
	tasks: VehicleJourneySegment[],
	taskId: string
): any | undefined => {
	for (const segment of tasks) {
		const stopTasks = segment.stop?.tasks || []
		for (const task of stopTasks) {
			if (task.id === taskId) {
				return task
			}
		}
	}
}
